// Debounce with maxWait, flush and cancel (the parts of lodash.debounce that autosave needs).
// Calls fn with the latest arguments once there's been no call for `wait` ms, or once
// `maxWait` ms have passed since the first call that hasn't been sent yet.
export const debounce = (fn, wait, { maxWait } = {}) => {
  let waitTimer = null;
  let maxTimer = null;
  let pendingArgs = null;

  const clearTimers = () => {
    clearTimeout(waitTimer);
    clearTimeout(maxTimer);
    waitTimer = null;
    maxTimer = null;
  };

  const flush = () => {
    if (!pendingArgs) return undefined;
    const args = pendingArgs;
    pendingArgs = null;
    clearTimers();
    return fn(...args);
  };

  const debounced = (...args) => {
    pendingArgs = args;
    clearTimeout(waitTimer);
    waitTimer = setTimeout(flush, wait);
    if (maxWait !== undefined && !maxTimer) {
      maxTimer = setTimeout(flush, maxWait);
    }
  };

  debounced.flush = flush;
  debounced.cancel = () => {
    pendingArgs = null;
    clearTimers();
  };
  debounced.isPending = () => pendingArgs !== null;

  return debounced;
};
